// Barra de la vista de ejemplo de la Mesa de servicio (CC-CONSOLE#1598).
//
// • Vista activa: banner FIJO «Vista de ejemplo de X: no ves la mesa real»
//   con un botón para salir. Es lo único que se ve distinto mientras la mesa
//   enseña sólo los tickets de esa compañía.
// • Vista apagada: si la compañía seleccionada tiene el Sandbox encendido, un
//   botón discreto «Ver tickets de ejemplo» (la única puerta de entrada).
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSandboxStore } from "../../../features/sandbox/sandboxStore";
import { useSampleViewStore } from "../services/sampleView";

export function SampleViewBar() {
  const { t } = useTranslation("common");
  const active = useSampleViewStore((s) => s.active);
  const view = useSampleViewStore((s) => s.view);
  const enter = useSampleViewStore((s) => s.enter);
  const exit = useSampleViewStore((s) => s.exit);
  const sandboxEnabled = useSandboxStore((s) => s.enabled);
  const loadSandbox = useSandboxStore((s) => s.load);

  useEffect(() => {
    void loadSandbox();
  }, [loadSandbox]);

  if (active) {
    const company = view?.companyName || view?.companyId || t("serviceDeskSampleView.thisCompany", { defaultValue: "esta compañía" });
    return (
      <div
        role="status"
        data-testid="sd-sample-view-banner"
        className="sticky top-0 z-20 flex flex-wrap items-center justify-between gap-2 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-800 dark:border-amber-500/40 dark:bg-amber-500/10 dark:text-amber-200"
      >
        <span className="flex items-center gap-2">
          <i className="ri-flask-line" aria-hidden="true" />
          {t("serviceDeskSampleView.banner", {
            company,
            defaultValue: "Vista de ejemplo de {{company}}: no ves la mesa real",
          })}
        </span>
        <button
          type="button"
          onClick={() => {
            exit();
            window.location.reload();
          }}
          className="rounded-md border border-amber-400 px-3 py-1 text-xs font-semibold hover:bg-amber-100 dark:hover:bg-amber-500/20"
        >
          {t("serviceDeskSampleView.exit", { defaultValue: "Salir de la vista de ejemplo" })}
        </button>
      </div>
    );
  }

  if (!sandboxEnabled) return null;
  return (
    <div className="flex justify-end px-4 pt-3">
      <button
        type="button"
        data-testid="sd-sample-view-enter"
        onClick={() => {
          enter();
          window.location.reload();
        }}
        className="inline-flex items-center gap-1 rounded-full border border-dashed border-amber-400 px-3 py-1 text-xs font-semibold text-amber-600 hover:bg-amber-50 dark:text-amber-300 dark:hover:bg-amber-500/10"
      >
        <i className="ri-flask-line" aria-hidden="true" />
        {t("serviceDeskSampleView.enter", { defaultValue: "Ver tickets de ejemplo" })}
      </button>
    </div>
  );
}
